<template>
  <div class="card-compProduto-produto-novo">
    <!-- <div class="titulo-fluxos"> COMPONENTES DO PRODUTO </div>
    <div class="subtitulo-fluxos"> Informe quantos e quais componentes o produto terá </div> -->

    <g-titulo-steps
    titulo="COMPONENTES DO PRODUTO"
    subtitulo="Informe quantos e quais componentes o produto terá"
    :imagemEmpresa = imagemEmpresa
    />
    <div class="espacamento-fluxos">
      <g-data-table
      class="data-table-conteudo"
      TextoVazio="Nenhum Componente Adicionado"
      Titulo="Componentes"
      :colunas="Colunas"
      :valores="informacao"
      :NumeroLinhas="8"
      v-on:editar="editar"
      v-on:excluir="excluir"
      :Editavel="!reorcamento"
      :EscondeColunaBotao="reorcamento || copiaOrcamentoQuantidade"
      >
      </g-data-table>
    </div>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="step6" 
        ref="botaoContinuar"
        >
          CONTINUAR
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="voltarstep3" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>

    <PDialog  class="gama-popup" :modal="true" v-model:visible="popupadicionarcomponente" :style="{ width: '85%', margin: '0 5%', minWidth: '300px', maxWidth: '65em' }">
      <template #header>
        <div class="titulo-formulario"> {{ehEdicao ? 'EDITAR' : 'ADICIONAR'}} COMPONENTE </div>
      </template>

      <div class="adicionar-componentes-conteudo-popup">
        <div class="titulo-grupo-detalhes"> Componente </div>
        <div class="grupo-dados-componente grupo">
          <div class="componente">
            <div class="titulo-conteudo-fluxos"> Componente <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="TipoComponenteArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Selecione"
            v-model="novoComponente.ComponenteTipo"
            @change="verificaComponenteTipo"
            >
            </PDropDown>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> Medidas </div>
        <div class="grupo-dados-medidas grupo">
          <div class="medidas-comprimento">
            <div class="titulo-conteudo-fluxos"> Comprimento (cm) <strong v-if="ObrigatoriedadeCampos" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            :value="novoComponente.NumeroComprimento"
            v-model="novoComponente.NumeroComprimento"
            :max="100000000"
            locale="pt-BR"
            :minFractionDigits="2"
            @click="limparConforme"
            >
            </PInputNumber>
          </div>

          <div class="medidas-largura">
            <div class="titulo-conteudo-fluxos"> Largura (cm) <strong v-if="ObrigatoriedadeCampos" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            :value="novoComponente.NumeroLargura"
            v-model="novoComponente.NumeroLargura"
            :max="100000000"
            locale="pt-BR"
            :minFractionDigits="2"
            @click="limparConforme"
            >
            </PInputNumber>
          </div>

          <div class="medidas-altura">
            <div class="titulo-conteudo-fluxos"> Altura (cm) <strong v-if="ObrigatoriedadeCampos" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            :value="novoComponente.NumeroAltura"
            v-model="novoComponente.NumeroAltura"
            @click="limparConforme"
            :max="100000000"
            locale="pt-BR"
            :minFractionDigits="2"
            >
            </PInputNumber>
          </div>

          <div class="medidas-altura-tampa">
            <div class="titulo-conteudo-fluxos"> Altura da Tampa (cm) <strong v-if="!ObrigatoriedadeAlturaTampaComp" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            :disabled="ObrigatoriedadeAlturaTampaComp"
            :value="novoComponente.NumeroAlturaTampa"
            v-model="novoComponente.NumeroAlturaTampa"
            :max="100000000"
            locale="pt-BR"
            :minFractionDigits="2"
            @click="limparConforme"
            >
            </PInputNumber>
          </div>

          <div class="medidas-ou-conforme">
            <div class="medidas-ou">
              <div class="titulo-conteudo-fluxos label-ou"> OU </div>
            </div>

            <div class="medidas-conforme">          
              <div class="titulo-conteudo-fluxos"> Conforme <strong v-if="ObrigatoriedadeConforme" class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              :options="MedidaConformeArray"
              @change="limparCamposMedidas"
              optionLabel="text"
              optionValue="value"
              placeholder="Insira a medida"
              v-model="novoComponente.DescricaoMedidas"
              >
              </PDropDown>
            </div>
          </div>
          
          <div class="medidas-unidade" v-if="this.novoComponente.DescricaoMedidas == 0">
            <div class="linha1 linha-separacao"></div>

            <div class="titulo-conteudo-fluxos"> Unidade <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
              v-model="UnidadeSelecionadaComponenteTipo"
              :options="UnidadeArrayComponenteTipo"
              @change="limparProdutoMaterial"
              optionLabel="nome"
              optionValue="id"
              placeholder="Insira a unidade"
            >
            </PDropDown>
          </div>

          <div class="medidas-produto" v-if="this.novoComponente.DescricaoMedidas == 0">
            <div class="linha1 linha-separacao"></div>

            <div class="titulo-conteudo-fluxos"> Produto <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            v-model="ProdutoMaterialId"
            :options="ProdutoOpcoes"
            @filter="buscarProdutosConformeProduto($event.value)"
            optionLabel="labelProduto"
            optionValue="produtoId"
            placeholder="Selecione a Referência"
            :filter="true"
            >
              <template #option="slotProps">
                <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
              </template>
            </PDropDown>
          </div>

          <div class="medidas-numero-prototipo" v-if="this.novoComponente.DescricaoMedidas == 1">
            <div class="titulo-conteudo-fluxos"> Número do Protótipo <strong class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            placeholder="Selecione..."
            v-model="numeroPrototipoComponenteTipo"
            >
            </PInputNumber>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> Materiais e Características </div>
        <div class="grupo-dados-materiais grupo">
          <div class="material">
            <div class="titulo-conteudo-fluxos"> Material <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="MaterialArray"
            @change="desativarCamposMateriais"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira o material"
            v-model="novoComponente.DescricaoMaterial"
            >
            </PDropDown>
          </div>

          <div class="materiais-onda">
            <div class="titulo-conteudo-fluxos"> Onda </div>
            <PDropDown
            :disabled="this.novoComponente.DescricaoMaterial == 1 || this.novoComponente.DescricaoMaterial == 3 || this.novoComponente.DescricaoMaterial == 4 || this.novoComponente.DescricaoMaterial == 5 || this.novoComponente.DescricaoMaterial == 6 || this.novoComponente.DescricaoMaterial == 8"
            :options="OndaArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira a onda"
            v-model="novoComponente.DescricaoOnda"
            >
            </PDropDown>
          </div>

          <div class="capa-externa">
            <div class="titulo-conteudo-fluxos"> Capa Externa <strong v-if="!ObrigatoriedadeDescricaoCapaExternaComp" class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :disabled="ObrigatoriedadeDescricaoCapaExternaComp"
            :options="CapaExternaArray"
            optionLabel="text"
            optionValue="value"
            :placeholder="` ${this.novoComponente.DescricaoMaterial == 8 ? 'PVC' : 'Insira'}`"
            v-model="novoComponente.DescricaoCapaExterna"
            >
            </PDropDown>
          </div>

          <div class="gramatura-capa-externa">
            <div class="titulo-conteudo-fluxos"> Gramatura Capa Externa <strong v-if="!ObrigatoriedadeGramaturaCapaExternaComp" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
              :disabled="ObrigatoriedadeGramaturaCapaExternaComp"
              maxlength="30"
              :value="novoComponente.NumeroGramaturaCapaExterna"
              v-model="novoComponente.NumeroGramaturaCapaExterna"
              locale="pt-BR"
              :minFractionDigits="0"
              >
              </PInputNumber>
          </div>

          <div class="materiais-papel-onda">
            <div class="titulo-conteudo-fluxos"> Papel de Onda <strong v-if="!ObrigatoriedadePapelDeOndaComp" class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :disabled="ObrigatoriedadePapelDeOndaComp"
            :options="PapelOndaArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira o papel"
            v-model="novoComponente.DescricaoPapelOnda"
            >
            </PDropDown>
          </div>

          <div class="materiais-gramatura">
            <div class="titulo-conteudo-fluxos"> Gramatura <strong v-if="!ObrigatoriedadePapelDeOndaComp" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            :disabled="ObrigatoriedadePapelDeOndaComp"
            :max="100000000"
            locale="pt-BR"
            :minFractionDigits="0"
            :value="novoComponente.NumeroGramaturaPapelOnda"
            v-model="novoComponente.NumeroGramaturaPapelOnda"
            >
            </PInputNumber>
          </div>

          <div class="capa-interna">
            <div class="titulo-conteudo-fluxos"> Capa Interna <strong v-if="!ObrigatoriedadeCapaInternaComp" class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :disabled="ObrigatoriedadeCapaInternaComp"
            :options="CapaInternaArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira"
            v-model="novoComponente.DescricaoCapaInterna"
            >
            </PDropDown>
          </div>

          <div class="gramatura-capa-interna">
            <div class="titulo-conteudo-fluxos"> Gramatura Capa Interna <strong v-if="!ObrigatoriedadeCapaInternaComp" class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            locale="pt-BR"
            :minFractionDigits="0"
            :disabled="ObrigatoriedadeCapaInternaComp"
            :value="novoComponente.NumeroGramaturaCapaInterna"
            v-model="novoComponente.NumeroGramaturaCapaInterna"
            >
            </PInputNumber>
          </div>
          
          <div class="materiais-numero-prototipo" v-if="this.novoComponente.DescricaoMaterial == 7">
            <div class="titulo-conteudo-fluxos"> Número do protótipo <strong class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            placeholder="Selecione..."
            v-model="numeroPrototipoMaterial"
            >
            </PInputNumber>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> Cores e Acabamento </div>
        <div class="grupo-dados-cores grupo">
          <div class="cor-frente">
            <div class="titulo-conteudo-fluxos"> Cor Frente <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="CorFrenteArray"
            optionLabel="text"
            placeholder="Insira a Cor"
            v-model="novoComponente.DescricaoCoresFrente"
            optionValue="value"
            >
            </PDropDown>
          </div>

          <div class="cor-verso">
            <div class="titulo-conteudo-fluxos"> Cor Verso <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="CorVersoArray"
            optionLabel="text"
            placeholder="Insira a Cor"
            v-model="novoComponente.DescricaoCoresVerso"
            optionValue="value"
            >
            </PDropDown>
          </div>

          <div class="cores-acabamento-frente">
            <div class="titulo-conteudo-fluxos"> Acabamento Frente <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="CorFrenteAcabamentoArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira"
            v-model="novoComponente.DescricaoAcabamentoFrente"
            >
            </PDropDown>
          </div>

          <div class="cores-acabamento-verso">
            <div class="titulo-conteudo-fluxos"> Acabamento Verso <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="CorVersoAcabamentoArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira"
            v-model="novoComponente.DescricaoAcabamentoVerso"
            >
            </PDropDown>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> Demais Informações </div>
        <div class="grupo-dados-demaisInfo grupo">
          <div class="demaisInfo-sistema">
            <div class="titulo-conteudo-fluxos"> Sistema <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            :options="SistemaArray"
            optionLabel="text"
            optionValue="value"
            placeholder="Insira o Sistema"
            v-model="SistemaSelecionado"
            @change="VerificacaoSistema"
            >
            </PDropDown>
          </div>

          <div class="demaisInfo-unidade" v-if="this.SistemaSelecionado == 2 || this.SistemaSelecionado == 0">
            <div class="titulo-conteudo-fluxos"> Unidade<strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            v-model="UnidadeSelecionadaSistema"
            :options="UnidadeArray"
            @change="limparProdutoSistema"
            optionLabel="nome"
            optionValue="id"
            placeholder="Insira a unidade"
            >
            </PDropDown>
          </div>

          <div class="demaisInfo-produto" v-if="this.SistemaSelecionado == 2">
            <div class="titulo-conteudo-fluxos"> Produto <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            v-model="ProdutoSistemaId"
            :options="ProdutoOpcoesProdutoNumero"
            @filter="buscarProdutosProdutoNumero($event.value)"
            optionLabel="labelProduto"
            optionValue="produtoId"
            placeholder="Selecione a Referência"
            :filter="true"
            :disabled="UnidadeSelecionadaSistema == ''"
            >
              <template #option="slotProps">
                <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
              </template>
            </PDropDown>
          </div>

          <div class="demaisInfo-produto" v-if="this.SistemaSelecionado == 0">
            <div class="titulo-conteudo-fluxos"> Produto <strong class="asterisco-obrigatorio">*</strong></div>
            <PDropDown
            v-model="SistemaId"
            :options="ProdutoSistemaOpcoes"
            optionLabel="codigoSistemaDecricao"
            optionValue="id" 
            placeholder="Selecione a Referência"
            @filter="GetProdutoByTableSistema($event.value)"
            :filter="true"
            :disabled="UnidadeSelecionadaSistema == ''"
            >
            </PDropDown>
          </div>

          <div class="demaisInfo-numero-prototipo" v-if="this.SistemaSelecionado == 3">
            <div class="titulo-conteudo-fluxos"> Número do protótipo <strong class="asterisco-obrigatorio">*</strong></div>
            <PInputNumber
            placeholder="Selecione..."
            v-model="numeroPrototipoSistema"
            >
            </PInputNumber>
          </div>
        </div>
      </div>

      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="cancelandoadicionarcomponente"
          >
            CANCELAR
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="adicionandocomponente"
          >
            {{ehEdicao ? 'EDITAR' : 'ADICIONAR'}}
          </g-button>
        </div>
      </div>
    </PDialog>
    <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

  </div>
</template>

<script>
import CompProdutoRA from './CompProdutoRA.js'
export default CompProdutoRA
</script>

<style scoped>
.titulo-grupo-detalhes {
  margin-bottom: 15px;
}

.label-ou {
  text-align: center;
}

@media (min-width: 310px) {
.adicionar-componentes-conteudo-popup {
  padding: 0 10px 50px;
}

.grupo {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.medidas-ou-conforme {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.medidas-ou {
  display: flex;
}
}

@media (min-width:368px) {

}

@media (min-width:400px) {
.adicionar-componentes-conteudo-popup {
  padding: 0 20px 50px;
}
}

@media (min-width: 600px) {
.grupo {
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 15px;
}

.componente { width: 60%; }

.grupo-dados-medidas {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(7, auto);
}
.medidas-comprimento { grid-area: 1 / 1 / 2 / 3; }
.medidas-largura { grid-area: 1 / 3 / 2 / 5; }
.medidas-altura { grid-area: 2 / 1 / 3 / 3; }
.medidas-altura-tampa { grid-area: 2 / 3 / 3 / 5; }

.medidas-ou-conforme { 
  grid-area: 3 / 1 / 4 / 5; 
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
  row-gap: 0;
  grid-row-gap: 0; 
}
.medidas-ou { grid-area: 1 / 1 / 2 / 5; }
.medidas-conforme { grid-area: 2 / 1 / 3 / 4; }
.linha1 { margin: 5px 0 15px; }
.medidas-unidade { grid-area: 4 / 1 / 5 / 5; }
.medidas-produto { grid-area: 5 / 1 / 6 / 5; }
.medidas-numero-prototipo { grid-area: 6 / 1 / 7 / 3; }

.grupo-dados-materiais {
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(5, auto);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}

.material { grid-area: 1 / 1 / 2 / 3; }
.materiais-onda { grid-area: 1 / 3 / 2 / 5; }
.capa-externa { grid-area: 2 / 1 / 3 / 3; }
.gramatura-capa-externa { grid-area: 2 / 3 / 3 / 5; }
.materiais-papel-onda { grid-area: 3 / 1 / 4 / 3; }
.materiais-gramatura { grid-area: 3 / 3 / 4 / 5; }
.capa-interna { grid-area: 4 / 1 / 5 / 3; }
.gramatura-capa-interna { grid-area: 4 / 3 / 5 / 5; }
.materiais-numero-prototipo { grid-area: 5 / 1 / 6 / 3; width: 100%; }

.grupo-dados-cores{
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.cor-frente{ grid-area: 1 / 1 / 2 / 3; }
.cor-verso{ grid-area: 1 / 3 / 2 / 5; }
.cores-acabamento-frente{ grid-area: 2 / 1 / 3 / 3; }
.cores-acabamento-verso{ grid-area: 2 / 3 / 3 / 5; }

.demaisInfo-numero-prototipo {
  width: 50%;
}
}

@media (min-width: 700px) {

}

@media (min-width: 801px) {
.grupo-dados-medidas {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
}
.medidas-comprimento { grid-area: 1 / 1 / 2 / 3; }
.medidas-largura { grid-area: 1 / 3 / 2 / 5; }
.medidas-altura { grid-area: 1 / 5 / 2 / 7; }
.medidas-altura-tampa { grid-area: 2 / 1 / 3 / 3; }
.medidas-ou-conforme { 
  grid-area: 2 / 3 / 3 / 7; 
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.medidas-ou { grid-area: 1 / 1 / 2 / 2; align-self: end; }
.medidas-conforme { grid-area: 1 / 2 / 2 / 5; }
.medidas-unidade { grid-area: 3 / 1 / 4 / 4; }
.medidas-produto { grid-area: 3 / 4 / 4 / 7; }
.medidas-numero-prototipo { grid-area: 4 / 1 / 5 / 3; }

.grupo-dados-demaisInfo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "3" : "2"'), auto);
  grid-column-gap: 20px;
  grid-row-gap: 15px;
}
.demaisInfo-sistema { grid-area: 1 / 1 / 2 / 3; }
.demaisInfo-unidade { grid-area: v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "2 / 1 / 3 / 2" : ""'); }
.demaisInfo-produto { grid-area: v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "2 / 2 / 3 / 3" : ""'); }
.demaisInfo-numero-prototipo { grid-area: v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "3 / 1 / 4 / 2" : ""'); width: 100%; }
}

@media (min-width: 1025px) {
.componente { width: 50%; }


.grupo-dados-demaisInfo {
  grid-template-rows: repeat(v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "2" : "1"'), auto);
}
.demaisInfo-sistema { grid-area: 1 / 1 / 2 / 2; }
.demaisInfo-unidade { grid-area: v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "1 / 2 / 2 / 3" : ""'); }
.demaisInfo-produto { grid-area: v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? "2 / 1 / 3 / 2" : ""'); }
.demaisInfo-numero-prototipo { grid-area: v-bind('SistemaSelecionado == 2 || SistemaSelecionado == 0 ? " 2 / 2 / 3 / 3" : "1 / 2 / 2 / 3"');  width: 50%; }
}

@media (min-width: 1281px) {
.grupo-dados-medidas {
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
}
.medidas-comprimento { grid-area: 1 / 1 / 2 / 3; }
.medidas-largura { grid-area: 1 / 3 / 2 / 5; }
.medidas-altura { grid-area: 1 / 5 / 2 / 7; }
.medidas-altura-tampa { grid-area: 1 / 7 / 2 / 9; }
.medidas-ou-conforme { 
  grid-area: 2 / 1 / 3 / 9; 
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.medidas-ou { grid-area: 1 / 1 / 2 / 2; }
.medidas-conforme { grid-area: 1 / 2 / 2 / 5; }
.medidas-unidade { grid-area: 3 / 1 / 4 / 5; }
.medidas-produto { grid-area: 3 / 5 / 4 / 9; }
.medidas-numero-prototipo { grid-area: 4 / 1 / 5 / 3; }

.grupo-dados-materiais {
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: repeat(6, auto);
}
.material { grid-area: 1 / 1 / 2 / 5; }
.materiais-onda { grid-area: 1 / 5 / 2 / 9; }
.capa-externa { grid-area: 2 / 1 / 3 / 5; }
.gramatura-capa-externa { grid-area: 2 / 5 / 3 / 9; }
.materiais-papel-onda { grid-area: 3 / 1 / 4 / 5; }
.materiais-gramatura { grid-area: 3 / 5 / 4 / 9; }
.capa-interna { grid-area: 4 / 1 / 6 / 5; }
.gramatura-capa-interna { grid-area: 4 / 5 / 5 / 9; }
.materiais-numero-prototipo { grid-area: 5 / 1 / 6 / 5; width: 100%; }

.grupo-dados-cores {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.cor-frente { grid-area: 1 / 1 / 2 / 2; }
.cor-verso { grid-area: 1 / 2 / 2 / 3; }
.cores-acabamento-frente { grid-area: 1 / 3 / 2 / 4; }
.cores-acabamento-verso { grid-area: 1 / 4 / 2 / 5; }
}

@media (min-width: 1500px) {
.adicionar-componentes-conteudo-popup {
  padding: 0 100px 50px;
}
}

@media (min-width:1800px) {
.espacamento-fluxos {
  padding: 0 13% 25px;
}

.adicionar-componentes-conteudo-popup {
  padding: 0 8% 50px;
}
}

@media (min-width:2000px) {
.espacamento-fluxos {
  padding: 0 20% 25px;
}
}
</style>
